// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3nfY0","content":"GlobalSearch_content__CO4K0"};